import { appendPathAsClassname, defineCustomElementVue } from '@/common/utils';

import MmmHeaderCe from './components/mmm-header.ce.vue';

appendPathAsClassname();

defineCustomElementVue({
  'mmm-header': MmmHeaderCe,
});
